import React, { useState, useEffect, useContext } from "react";
import cx from "classnames";
import { apiClient } from "../../connections/apiClient";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../services/reducers/authReducer";
import AuthContext from "../../connections/auth/AuthProvider";
import { ThreeDots } from "react-loader-spinner";

import { makeStyles } from "@material-ui/core/styles";

import styles from "../../assets/jss/material-dashboard-pro-react/layouts/welcomeStyle";
import { grayColor } from "../../assets/jss/material-dashboard-pro-react";
import apiRoutes from "../../connections/apiRoutes";
import { store } from "../../store";

const useStyles = makeStyles(styles);

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default function Welcome() {
  const classes = useStyles();
  const history = useHistory();

  const [init, setInit] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [splashColor, setSplashColor] = useState("#fff");
  const [clientLogo, setClientLogo] = useState(null);
  const [clientLogoFade, setClientLogoFade] = useState(false);

  const dispatch = useDispatch();
  const { logoutUser } = useContext(AuthContext);

  useEffect(() => {
    const runWelcomeFlow = async () => {
      setInit(false);

      const token = store.getState().auth.authTokens?.access;
      if (!token) {
        logoutUser(null, "Sua sessão expirou. Faça login novamente.");
        return;
      }

      try {
        const response = await apiClient.post(
          apiRoutes.accounts_postlogin_info,
          {},
        );
        dispatch(setUserDetails(response.data));
        setClientLogo(response.data.implementation_logo);

        await sleep(500);
        setIsLoaded(true);

        await sleep(1500);
        setSplashColor("#eee");
        setClientLogoFade(true);

        await sleep(250);
        history.push("/main/cockpit");
      } catch (error) {
        console.error(error);
        logoutUser(null, "Erro ao carregar dados do projeto. Tente novamente.");
      }
    };

    runWelcomeFlow();
  }, []);

  return (
    <>
      <div className={classes.wrapper}>
        <div
          className={cx({
            [classes.welcomeText]: true,
            ["init"]: init,
            ["loaded"]: isLoaded,
          })}
        >
          {"welcome"}
        </div>
        <ThreeDots
          color={grayColor[0]}
          ariaLabel="loading"
          height={"12px"}
          wrapperStyle={{}}
          wrapperClass={cx({
            [classes.welcomeSpinner]: true,
            ["init"]: init,
          })}
        />
      </div>
      <div
        className={cx({
          [classes.clientSplash]: true,
          ["loaded"]: isLoaded,
        })}
        style={{ backgroundColor: splashColor }}
      >
        {clientLogo && (
          <img
            src={`data:image/png;base64,${encodeURIComponent(clientLogo)}`}
            alt="logo"
            className={cx({
              [classes.clientLogo]: true,
              ["faded"]: clientLogoFade,
            })}
          />
        )}
      </div>
    </>
  );
}
